import { CheckoutState } from '../../state';
import { isIosWebView } from '../../utils/browser';
import { areSyncExpressCheckoutEligibleCommonRulesMet } from '../expressCheckoutConditions';
import { isTLDWithApplePayEnabled } from './isTLDWithApplePayEnabled';
import { getIsApplePaySupported } from './pureSelectors';

export const areSyncExpressApplePayEligibleRulesMet = (state: CheckoutState) =>
    areSyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isIosWebView() &&
    isTLDWithApplePayEnabled(state) &&
    getIsApplePaySupported(state);
